module.exports = __webpack_public_path__ + "static/media/APYS-BNB.f2759409.svg";